import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Switch } from './ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const EventsCalendarEditor = ({ content, onChange }) => {
  const [groups, setGroups] = useState([]);
  const set = (patch) => onChange({ ...content, ...patch });

  useEffect(() => {
    let active = true;
    api.get('/events/groups')
      .then((res) => { if (active) setGroups(res.data || []); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <Label className="text-xs">Section Title</Label>
        <Input
          data-testid="events-block-title"
          value={content.title || ''}
          onChange={(e) => set({ title: e.target.value })}
          placeholder="Upcoming Events"
        />
      </div>

      <div className="space-y-1">
        <Label className="text-xs">Default view</Label>
        <Select value={content.defaultView || 'calendar'} onValueChange={(v) => set({ defaultView: v })}>
          <SelectTrigger data-testid="events-block-view"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="calendar">Calendar (month grid)</SelectItem>
            <SelectItem value="list">List (upcoming)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1">
        <Label className="text-xs">Show events for</Label>
        <Select value={content.groupId || 'all'} onValueChange={(v) => set({ groupId: v === 'all' ? '' : v })}>
          <SelectTrigger data-testid="events-block-group"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All events (everyone)</SelectItem>
            {groups.map((g) => (
              <SelectItem key={g.group_id} value={g.group_id}>{g.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-[11px] text-slate-400">Filters to "everyone" events plus events targeted at this group.</p>
      </div>

      <div className="space-y-1">
        <Label className="text-xs">Max events shown (list view)</Label>
        <Input
          type="number"
          min="1"
          data-testid="events-block-limit"
          value={content.limit ?? 10}
          onChange={(e) => set({ limit: parseInt(e.target.value, 10) || 10 })}
        />
      </div>

      <div className="flex items-center justify-between border rounded-lg p-3 bg-slate-50">
        <div>
          <Label className="text-xs">Allow RSVP in the popup</Label>
          <p className="text-[11px] text-slate-400">Visitors can register without leaving this page.</p>
        </div>
        <Switch
          data-testid="events-block-rsvp"
          checked={content.showRsvp !== false}
          onCheckedChange={(v) => set({ showRsvp: v })}
        />
      </div>

      <div className="flex items-center justify-between border rounded-lg p-3 bg-slate-50">
        <div>
          <Label className="text-xs">Show "Subscribe (iCal)" button</Label>
        </div>
        <Switch
          data-testid="events-block-ical"
          checked={content.showIcal !== false}
          onCheckedChange={(v) => set({ showIcal: v })}
        />
      </div>
    </div>
  );
};

export default EventsCalendarEditor;
